//
//
//
//
//
//
//
//

import $manager from "@/Manager/049.SmartGms/PrizeStockOutProductOrderManager.js";
import PageIndex from "@/0/components/0.comPage/01.comPageIndex";
export default {
  components: { 
    "page-index": PageIndex 
  },
  data() {
    return {
      
      dataConfig: {

      },      

    };
  },

  methods: {
    getManager() {
      return $manager;
    },

    getDetailUrl() {
      return "/Tpl/Template2/Detail";
    },

  }
};
